import { centsToFormattedDollars } from '@fruitful/fruitils';
import { MembershipBillingFrequency } from '@fruitful/types';

const BILLING_FREQUENCY_PAYMENT_TERMS: Record<
    MembershipBillingFrequency,
    string
> = {
    [MembershipBillingFrequency.MONTHLY]: 'every month',
    [MembershipBillingFrequency.QUARTERLY]: 'every 3 months',
    [MembershipBillingFrequency.YEARLY]: 'for 1 year',
};

export const BILLING_FREQUENCY_INTERVAL_MONTHS: Record<
    MembershipBillingFrequency,
    number
> = {
    [MembershipBillingFrequency.MONTHLY]: 1,
    [MembershipBillingFrequency.QUARTERLY]: 3,
    [MembershipBillingFrequency.YEARLY]: 12,
};

/** Short caption under the price on the billing-frequency toggle cards. */
const BILLING_FREQUENCY_TOGGLE_CAPTION: Record<
    MembershipBillingFrequency,
    string
> = {
    [MembershipBillingFrequency.MONTHLY]: 'billed monthly',
    [MembershipBillingFrequency.QUARTERLY]: 'every 3 months',
    [MembershipBillingFrequency.YEARLY]: 'billed annually',
};

export const getBillingFrequencyToggleCaption = (
    billingFrequency: MembershipBillingFrequency,
): string => BILLING_FREQUENCY_TOGGLE_CAPTION[billingFrequency];

export const getBillingFrequencyLabel = (
    billingFrequency: MembershipBillingFrequency,
): string => {
    switch (billingFrequency) {
        case MembershipBillingFrequency.MONTHLY:
            return 'Monthly';
        case MembershipBillingFrequency.QUARTERLY:
            return 'Quarterly';
        case MembershipBillingFrequency.YEARLY:
            return 'Annual';
    }
};

export const formatPremiumPaymentTerms = (
    billingFrequency: MembershipBillingFrequency,
    amountDueNowCents: number,
): string =>
    `${centsToFormattedDollars(amountDueNowCents, false)} ${BILLING_FREQUENCY_PAYMENT_TERMS[billingFrequency]}`;
